<template>
  <div class="faqs">
    <h3 v-if="cmCopy !== ''">{{ cmCopy.title }}</h3>
    <p v-if="cmCopy !== ''" v-html="cmCopy.description "></p>
    <!-- Declaration -->
      <b-form-group v-if="!onboardingDone">
        <div class="checkbox checkbox-custom">
          <input id="faqRead" 
            name="faqRead" 
            type="checkbox" 
            :value="form.documentRead"
            v-model="documentRead"
            @input="handleInput('documentRead', $event.target.checked)"
          >
          <label for="faqRead">I confirm that I have read this document</label>
          <b-alert v-if="$v.form.documentRead.$error" show variant="danger">
            <p>You must tick this box in order to submit the onboarding documents</p>
          </b-alert>
        </div>
      </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { updateForm } from '../../helpers/index'
import { sameAs } from 'vuelidate/lib/validators'
import { fetchManagedContent } from '../../services/api'
export default {
  computed: {
    ...mapState({form: state => state.authStore.recruit.onboarding.onboardingForms.faq}),
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getToken: 'authStore/getToken',
    })
  },
  props: {
    onboardingDone: {
      type: Boolean, 
      default: false,
    }
  },
  data () {
    return {
      documentRead: '',
      formName: 'faq',
      cmCopy: '',
    }
  },
  mounted () {
    this.$v.$touch()
    this.getCMCopy()
    setTimeout(() => {
      this.documentRead = this.form.documentRead
    }, 1000)
  },
  updated () {
    // this.updateForm('valid', this.$v.$error)
    const validationData = {
      section: 'faq',
      status: !this.$v.form.$invalid
    }
    this.updateOnboardingCompleteAction(validationData)
  },
  methods: {
    ...mapActions({
      updateOnboardingFormAction: 'authStore/updateOnboardingFormAction',
      currentOnboardingFormAction: 'authStore/currentOnboardingFormAction',
      setRecruitAction: 'authStore/setRecruitAction',
      updateOnboardingCompleteAction: 'authStore/updateOnboardingCompleteAction'
    }),
    handleInput(input, e, nested, array, index, item) {
      this.updateForm(input, e, nested, array, index, item)
    },
    async getCMCopy() {
      let res = await fetchManagedContent(this.getToken,4)
      if (res && res.data) {
        this.cmCopy = res.data
      } 
    },
    updateForm
  },
  validations: {
    form: {
      documentRead: {
        sameAs: sameAs(() => true)
      }
    }
  }
}
</script>

<style scoped>
.question-group {
  width: 100%;
  margin: 2rem 0;
}
.q-a {
  display: grid;
  grid-template-columns: 10% 90%;
}
</style>
